module.exports = __webpack_public_path__ + "img/icon_map_hssh_c.6e50a6b4.png";